if (document.querySelectorAll('.header-center-search-link')) {
    document.addEventListener('DOMContentLoaded', () => {
        const searchLinks = document.querySelectorAll('.header-center-search-link');
        const searchForms = document.querySelectorAll('.search-form');
        const searchCloses = document.querySelectorAll('.search-close');
    
        if (searchLinks.length > 0 && searchForms.length > 0 && searchCloses.length > 0) {
            searchLinks.forEach((searchLink, index) => {
                const searchForm = searchForms[index];
                const searchClose = searchCloses[index];
    
                if (searchLink && searchForm && searchClose) {
                    searchLink.addEventListener('click', (e) => {
                        e.preventDefault();
                        searchForm.classList.add('active');
                    });
    
                    searchClose.addEventListener('click', () => {
                        searchForm.classList.remove('active');
                    });
                }
            });
        }
    });
}